module.exports = __webpack_public_path__ + "PORSCHE-logo.png";